import api from '@/core/connector/api.types';
import vueApp from '@/main';
import { getErrors, controlConnectionProblems } from '@/core/resolvers/error.resolver';

export default class ApiService {
  params;

  payload;

  url;

  loader;

  constructor() {
    this.setApiType();
    this.__setApi();
  }

  setApiType() {
    this.apiType = 'VUE_APP_API_URL';
  }

  setLoader() {
    this.loader = true;
    vueApp.$store.dispatch('setLoader', this.loader);
  }

  __setApi() {
    this.api = api(this.apiType);
  }

  setAuthorization(body) {
    if (vueApp.$store.state.token) {
      body.Authorization = vueApp.$store.state.token;
    }
  }

  async request(body) {
    this.setLoader();
    let result;
    try {
      body.url = this.url;
      body.headers = {
        ...body.headers,
        Accept: 'application/json',
      };
      this.setAuthorization(body.headers);
      result = await this.api(body);
    } catch (e) {
      this.__exit();
      controlConnectionProblems(e);
      throw getErrors(e);
    }
    this.__exit();
    return result.data;
  }

  async get() {
    return this.request({
      method: 'get',
      params: this.params,
    });
  }

  async put() {
    return this.request({
      method: 'put',
      data: this.payload,
    });
  }

  async post() {
    return this.request({
      method: 'post',
      data: this.payload,
      params: this.params,
    });
  }

  async delete() {
    return this.request({
      method: 'delete',
    });
  }

  async patch() {
    return this.request({
      method: 'patch',
      data: this.payload,
    });
  }

  async postFile() {
    return this.request({
      method: 'post',
      data: this.payload,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  __exit() {
    const currentStatus = this.loader;
    this.loader = false;
    if (currentStatus) {
      vueApp.$store.dispatch('setLoader', this.loader);
    }
  }
}
